import React, { useState } from "react";
import style from './orderDetailModal.module.scss';
import Modal from '../../Modal/Modal'
import toPersianNumber from "../../../helpers/actions/toPersianNumber";
import { numberWithCommas } from "../../../helpers/actions/splitNumberWithComma";


const OrderDetailModal = (props) => {

    return (
        <Modal
            tag='orderDetailModal'
            title='جزئیات سفارش‌ها'
            value={props.show}
            parentClose={props.closeModal}
        >
            <div className={style.tableWrapper}>
                <div className={style.tableHeader}>
                    <div className={style.listItem}><p>کد کالا</p></div>
                    <div className={style.listItem}><p>قیمت فروش</p></div>
                    <div className={style.listItem}><p>دریافتی از دیجی‌کالا</p></div>
                    <div className={style.listItem}><p>میزان سود</p></div>
                </div>
                {props.data && props.data.combinedData && props.data.combinedData.length > 0 && props.data.combinedData.map((itemData, itemDataIndex) => <div
                    key={`itemDataIndex_${itemDataIndex}`}
                    className={style.tableRow}
                >
                    <div className={style.listItem}><a target="_blank" href={`https://www.digikala.com/product/dkp-${props.data.product[0].DKP}`}><p>{toPersianNumber(props.data.product[0].DKPC)}</p></a></div>
                    <div className={style.listItem}><p>{toPersianNumber(numberWithCommas(itemData.price))}</p><span>ریال</span></div>
                    <div className={style.listItem}><p>{toPersianNumber(numberWithCommas(itemData.withoutDkCostTax))}</p><span>ریال</span></div>
                    <div className={style.listItem}><p>{toPersianNumber(numberWithCommas(itemData.profit))}</p><span>ریال</span></div>
                </div>)}
            </div>
        </Modal>
    )
}
export default OrderDetailModal

